import React from 'react';
import { Table, Image, Badge, Button } from 'react-bootstrap';
import Icon from '@mdi/react';

export default function TableElement({ tableSize, tableClass, thead, tbodydata, tfootdata }) {
    return (
        <>
            <Table responsive bordered size={tableSize} className={`${tableClass ? tableClass : ''}`}>
                {tbodydata && tbodydata.length > 0 && (
                    <thead className="table-light">
                        <tr>
                            {thead.map((header, index) => (
                                <th key={index}>{header}</th>
                            ))}
                        </tr>
                    </thead>
                )}
                {tbodydata && tbodydata.length > 0 && (
                    <tbody>
                        {tbodydata.map((row, rowIndex) => (
                            <tr key={rowIndex} className={row.rowhighlight ? "rowhighlight" : ""}>
                                {thead.map((header, colIndex) => {
                                    const key = header.toLowerCase().replace(/\s+|\.+|\(+|\)+/g, '');
                                    const col = row[key];
                                    if (!col) {
                                        console.warn(`Missing or undefined key: ${key} in row:`, row);
                                        return React.createElement(row.rowhighlight ? "th" : "td", { key: colIndex });
                                    }

                                    return React.createElement(
                                        row.rowhighlight ? "th" : "td",
                                        { key: colIndex },
                                        col.type === 'imageWithText' ? (
                                            <div className="d-flex align-items-center">
                                                <div className="flex-shrink-0">
                                                    <Image src={require(`../../images/user-img/${col.image}`)} alt={col.alt || ''} roundedCircle className={`avatar-28 ${col.imageClass || ''}`.trim()} />
                                                </div>
                                                <div className="flex-grow-1 ms-3">{col.text}</div>
                                            </div>
                                        ) : col.type === 'icon' ? (
                                            <Icon path={col.icon} className={`icon-size-16 ${col.iconClass || ''}`.trim()} />
                                        ) : col.type === 'badge' ? (
                                            <Badge bg={col.badgeColor || 'primary'} className={col.badgeClass}>{col.text}</Badge>
                                        ) : col.type === 'button' ? (
                                            <Button variant={col.btnColor} size={col.btnSize}>{col.text}</Button>
                                        ) : (
                                            col.text || ''
                                        )
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                )}
                {tfootdata && tfootdata.length > 0 && (
                    <tfoot className="table-light">
                        <tr>
                            {tfootdata.map((footer, index) => (
                                <th key={index}>{footer}</th>
                            ))}
                        </tr>
                    </tfoot>
                )}
            </Table>
        </>
    );
}
